import React, { useState, useEffect } from 'react';
import './Products.css';
import OrderForm from './OrderForm';
import { API_URL, IMAGE_BASE_URL } from '../config';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showOrderForm, setShowOrderForm] = useState(false);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}?action=get_products`);
      
      // Check if response is OK and is JSON
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await response.text();
        console.error('API returned HTML instead of JSON:', text.substring(0, 200));
        throw new Error('API returned HTML instead of JSON. Check backend URL and file location.');
      }
      
      const data = await response.json();
      if (data.success && data.data) {
        setProducts(data.data);
      }
    } catch (error) {
      console.error('Ürünler yükleme hatası:', error);
      console.error('API URL:', API_URL);
    }
    setLoading(false);
  };

  const handleOrderClick = (product) => {
    setSelectedProduct(product);
    setShowOrderForm(true);
  };

  const handleCloseOrderForm = () => {
    setShowOrderForm(false);
    setSelectedProduct(null);
  };

  const handleOrderSuccess = () => {
    setTimeout(() => {
      handleCloseOrderForm();
    }, 3000);
  };

  const defaultProducts = [
    {
      id: 1,
      name: 'Klasik Resume Çiğköfte',
      description: 'Geleneksel tarifle hazırlanmış, baharat harması ile lezzet taşıyan özgün çiğköfte.',
      price: 55,
      image_url: 'https://images.unsplash.com/photo-1555939594-58d7cb561341?w=400&h=300&fit=crop',
      badge: 'Popüler'
    },
    {
      id: 2,
      name: 'Resume Çiğköfte Menü',
      description: 'Çiğköfte + Patates + İçecek. Tam doyum paketi!',
      price: 85,
      image_url: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&h=300&fit=crop',
      badge: 'Paket'
    },
    {
      id: 3,
      name: 'Özel Resume Çiğköfte',
      description: 'Ekstra malzeme ve özel sosları ile hazırlanmış özel çiğköfte.',
      price: 65,
      image_url: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400&h=300&fit=crop',
      badge: 'Özel'
    },
    {
      id: 4,
      name: 'Resume Çiğköfte Tabağı',
      description: 'Salata ve pilav eşliğinde servis edilen özel çiğköfte.',
      price: 95,
      image_url: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400&h=300&fit=crop',
      badge: 'Lüks'
    },
    {
      id: 5,
      name: 'Resume Çiğköfte Omlet',
      description: 'Çiğköfte parçaları ile hazırlanmış lezzetli omlet.',
      price: 60,
      image_url: 'https://images.unsplash.com/photo-1455619452474-d2be8b1e4e31?w=400&h=300&fit=crop',
      badge: 'Yeni'
    },
    {
      id: 6,
      name: 'Resume Çiğköfte Köfte',
      description: 'Çiğköfte malzemelerinden yapılan sos eşliğinde köfte.',
      price: 70,
      image_url: 'https://images.unsplash.com/photo-1529042410759-befb1204b3ef?w=400&h=300&fit=crop',
      badge: 'Popüler'
    }
  ];

  const displayProducts = products.length > 0 ? products : defaultProducts;

  // Helper function to get image URL
  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return 'https://via.placeholder.com/320x220?text=Ürün';
    // If it's already a full URL (starts with http), return as is
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
      return imageUrl;
    }
    // Otherwise, prepend backend URL
    return `${IMAGE_BASE_URL}/${imageUrl}`;
  };

  return (
    <section id="products" className="products">
      <div className="products-container">
        <div className="section-header">
          <h2>Ürünlerimiz</h2>
          <p className="subtitle">Resume Çiğköfte'nin en lezzetli seçenekleri</p>
        </div>
        
        <div className="products-grid">
          {displayProducts.map(product => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img 
                  src={getImageUrl(product.image_url || product.image)} 
                  alt={product.name}
                  onError={(e) => e.target.src = 'https://via.placeholder.com/320x220?text=Ürün'}
                />
                <span className="product-badge">{product.badge}</span>
              </div>
              
              <div className="product-info">
                <h3>{product.name}</h3>
                <p>{product.description}</p>
                
                <div className="product-footer">
                  <span className="price">₺{typeof product.price === 'string' ? product.price.replace('₺', '') : product.price}</span>
                  <button 
                    className="add-button"
                    onClick={() => handleOrderClick(product)}
                  >
                    Sipariş Ver
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showOrderForm && selectedProduct && (
        <OrderForm
          product={selectedProduct}
          onClose={handleCloseOrderForm}
          onOrderSuccess={handleOrderSuccess}
        />
      )}
    </section>
  );
};

export default Products;
